"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.2.0 (NJsonSchema v10.3.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Services_1 = require("../../../Services");
var axios_1 = __importDefault(require("axios"));
var TraceClient = /** @class */ (function (_super) {
    __extends(TraceClient, _super);
    function TraceClient(configuration, baseUrl, instance) {
        var _this = _super.call(this, configuration) || this;
        _this.jsonParseReviver = undefined;
        _this.instance = instance ? instance : axios_1.default.create();
        _this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : _this.getBaseUrl("");
        return _this;
    }
    /**
     * API responsible for creating new trace/feedback.
     * @param body (optional) Trace Request Dto.
     * @return Success
     */
    TraceClient.prototype.trace = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v{version}/trace";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.instance.request(transformedOptions_);
        }).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTrace(_response);
        });
    };
    TraceClient.prototype.processTrace = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            // fix manualy the proxy
            return (_responseText);
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return TraceClient;
}(Services_1.BaseClientApi));
exports.TraceClient = TraceClient;
var ChannelTypes;
(function (ChannelTypes) {
    ChannelTypes["Other"] = "Other";
    ChannelTypes["IOS"] = "IOS";
    ChannelTypes["Android"] = "Android";
    ChannelTypes["ProfilePortal"] = "ProfilePortal";
    ChannelTypes["InvoicingPortal"] = "InvoicingPortal";
    ChannelTypes["AdminPortal"] = "AdminPortal";
})(ChannelTypes = exports.ChannelTypes || (exports.ChannelTypes = {}));
var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Internal"] = "Internal";
    FeedbackType["External"] = "External";
})(FeedbackType = exports.FeedbackType || (exports.FeedbackType = {}));
var TraceLevel;
(function (TraceLevel) {
    TraceLevel["Feedback"] = "Feedback";
    TraceLevel["Error"] = "Error";
})(TraceLevel = exports.TraceLevel || (exports.TraceLevel = {}));
var CreateTraceDto = /** @class */ (function () {
    function CreateTraceDto(data) {
        this.channelType = ChannelTypes.Other;
        this.traceDateTime = new Date();
        this.logUserId = true;
        this.logEmail = true;
        this.logClientProperties = true;
        this.feedbackType = FeedbackType.Internal;
        this.traceLevel = TraceLevel.Error;
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTraceDto.prototype.init = function (_data) {
        if (_data) {
            this.channelType = _data["channelType"];
            this.applicationVersion = _data["applicationVersion"];
            this.traceDateTime = _data["traceDateTime"];
            this.title = _data["title"];
            this.logUserId = _data["logUserId"];
            this.logEmail = _data["logEmail"];
            this.logClientProperties = _data["logClientProperties"];
            this.email = _data["email"];
            this.errorCode = _data["errorCode"];
            this.description = _data["description"];
            this.errorDetails = _data["errorDetails"];
            this.feedbackType = _data["feedbackType"];
            this.traceLevel = _data["traceLevel"];
            this.clientProperties = _data["clientProperties"];
        }
    };
    CreateTraceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTraceDto();
        result.init(data);
        return result;
    };
    CreateTraceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["channelType"] = this.channelType;
        data["applicationVersion"] = this.applicationVersion;
        data["traceDateTime"] = this.traceDateTime;
        data["title"] = this.title;
        data["logUserId"] = this.logUserId;
        data["logEmail"] = this.logEmail;
        data["logClientProperties"] = this.logClientProperties;
        data["email"] = this.email;
        data["errorCode"] = this.errorCode;
        data["description"] = this.description;
        data["errorDetails"] = this.errorDetails;
        data["feedbackType"] = this.feedbackType;
        data["traceLevel"] = this.traceLevel;
        data["clientProperties"] = this.clientProperties;
        return data;
    };
    CreateTraceDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CreateTraceDto();
        result.init(json);
        return result;
    };
    return CreateTraceDto;
}());
exports.CreateTraceDto = CreateTraceDto;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new Services_1.ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
//# sourceMappingURL=proxy.js.map